import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=579ed2b7&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=js&"
export * from "./newIndex.vue?vue&type=script&lang=js&"
import style0 from "./newIndex.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newIndex.vue?vue&type=style&index=1&id=579ed2b7&lang=scss&scoped=true&"
import style2 from "./newIndex.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ed2b7",
  null
  
)

export default component.exports